import React from "react";

function Loading() {
  return <img src={require("../Spinner.gif")} alt="Loading..." id="loading" />;
}

export default Loading;
